import { ExtraData } from "modules/order-management/order-form/order-item/add-new/extra-items/ExtraItems";
import { crankColors } from "modules/order-management/order-form/order-item/add-new/roller-shutter-group/data";

export interface itemGroup{
  key:number;
  id: number;
  location: string;
  rollerStyle?:string;
  width: number;
  height: number;
  controlSide?: string;
  controlLength?: string;
  fitting?: string;
  fittingTo?: string;
  note?: string;
  //Calculation result
  price?: string;
  itemCost?: string;
  fabricWidth?: string;
  fabricDrop?: string;
  rollerSize?:string;
  tubeType?:string;
  bottomBarCal?: string;
  topRoller?: string;
  controlStack?      : string;
  trackCut?         : string;
  bladeCut?         : string;
  noBracket?        : string;
  noOfBlade?        : string;

  heightL: number;
  heightR: number;
  pelmetSizeCal?: string;
  pelmetCut?: string;
  slatCut?: string;
  noSlat?: string;
  bot?: string;
  oct?: string;
  guideL?: string;
  guideR?: string;
  axels?:string;
  realWidth?         : string;
  realHeight?        : string;
  slatWidth ?      : number;

  cutTilt?       : number;
  layout?        : string;
  customLayout?  : string;
  frameCode?     : string;
  top?           : boolean;
  right?         : boolean;
  left?          : boolean;
  bottom?       : boolean;
  noPanel?       : number;
  midRail?       : number;
  mount?         : string;
  tPost?         : number;
  TPostSetting?  : string;

  stack?         : string;
  bracketType?   : string;

  extraBracket?  : number;
  extraSlat?     : number;
  bottomAngle?: number;


  hoodCut?: string;
  tubeCut?: string;
  bottomRail?: string;
  channelLeft?: string;
  channelRight?: string;
  tentionTrackLeft?: string;
  tentionTrackRight?: string;
  fabricWidthOnlySkin?: string;
  fabricWidthIncZip?: string;
  tubeSize?:string;
  wireLength?:string;


  jhookHeight?: number;
  valance?: number;
  controlLooking?: string;
  extraHeight?: string;
  pocketHeight?: string;
  awningHeight?: string;
  botBarPocket?: string;
  totalFabicHeight?: string;
  topTimberWidth?: string;
  bottomBarWidth?: string;
  hems?: string;
  totalWidth?: string;
  fabricUsedCal?: string;
  cordLength?: string;

  inPrice?: string;
  outPrice?:string;
  //EXTRA
  Extra: ExtraData;
}
export const InitialItem = {
  itemList: [] as itemGroup[],
  id:0,
  productId: '',
  isFitted: false,
  // Vertical Blinds
  controlSide: '',
  controlStyle: '',
  fabricDetail: '',
  fabricDetail2: '',
  fitting: '',
  height: 0,
  links: '',
  location: '',
  note: '',
  stackDirection: '',
  controlStack: '',
  controlLength: '',
  rollerStyle: '',
  controlMat :'',
  width: 0,
  blindType: {
    description: '',
    material_id: 0,
  },
  trackColour: {
    color: '',
    id: 0,
  },
  controlColor: {
    color: '',
    id: 0,
  },
  fabricCol: {
    color: '',
    id: 0,
  },
  subType: {
    description: '',
    id: 0,
  },
  // roller blinds
  tubeType:'',
  // bottomBarOther: '',
  fabricRotation: '',
  blindPelmet: '',
  operation: {
    description: '',
    id: 0,
  },
  curtainHeading: {
    description: '',
    id: 0,
  },
  liningOption: {
    description: '',
    id: 0,
  },
  bottomBarOpt:{
    description: '',
    id: 0,
  },
  bottomBar: {
    description: '',
    id: 0,
  },
  bottomBarBrand: {
    description: '',
    id: 0,
  },
  fabricType: {
    description: '',
    id: 0,
  },
  curverPattern: {
    description: '',
    id: 0,
  },
  // roller cassette
  cassetteColour: {
    description: '',
    id: 0,
  },
  otherColour: '',
  // roller shutter
  angleType: '',
  pelmetWidth:0,
  bottomGuide: '',
  pattern: '',
  bottomAngle: 0,
  heightL: 0,
  heightR: 0,
  pelmetColor: {
    color: '',
    id: 0,
  },
  guideColor: {
    color: '',
    id: 0,
  },
  bottomBarColor: {
    color: '',
    id: 0,
  },
  slatPrimaryColor: {
    color: '',
    id: 0,
  },
  slat2Color: {
    color: '',
    id: 0,
  },
  crankColors:{
    color: '',
    id: 0,
  },
  shutterType: {
    description: '',
    id: 0,
  },
  trackBrand: {
    description: '',
    id: 0,
  },
  guideType: {
    description: '',
    id: 0,
  },
  //  protecta
  fabricCatalog: {
    description: '',
    id: 0,
  },
  fabricName: '',
  channelColor: {
    color: '',
    id: 0,
  },
  hoodSize: {
    description: '',
    id: 0,
  },
  topRollerSize: {
    description: '',
    id: 0,
  },
  hoodColor: {
    color: '',
    id: 0,
  },
  powderColor:'',
  // awning
  bcaa: {
    description: '',
    id: 0,
  },
  valance: 0,
  valanceStyle: {
    description: '',
    id: 0,
  },
  hood: '',
  // shop front awning
  jhookHeight: 0,
  // EZE awning
  hoodType: {
    description: '',
    id: 0,
  },
};
export const InitialItemUndefined = {
  itemList:[] as itemGroup[],
  id:undefined,
  productId: '',
  isFitted: false,
  // Vertical Blinds
  controlSide: '',
  controlStyle: '',
  fabricDetail: '',
  fabricDetail2: '',
  fitting: '',
  height: 0,
  links: '',
  location: '',
  note: '',
  stackDirection: '',
  controlStack: '',
  controlLength: '',
  rollerStyle: '',
  controlMat :'',
  width: 0,
  blindType: {
    description: '',
    material_id: 0,
  },
  trackColour: {
    color: '',
    id: 0,
  },
  controlColor: {
    color: '',
    id: 0,
  },
  fabricCol: {
    color: '',
    id: 0,
  },
  subType: {
    description: '',
    id: 0,
  },
  // roller blinds
  tubeType:'',
  // bottomBarOther: '',
  fabricRotation: '',
  operation: {
    description: '',
    id: 0,
  },
  curtainHeading: {
    description: '',
    id: 0,
  },
  liningOption: {
    description: '',
    id: 0,
  },
  bottomBarOpt:{
    description: '',
    id: 0,
  },
  bottomBar: {
    description: '',
    id: 0,
  },
  bottomBarBrand: {
    description: '',
    id: 0,
  },
  fabricType: {
    description: '',
    id: 0,
  },
  fabricType2: {
    description: '',
    id: 0,
  },
  curverPattern: {
    description: '',
    id: 0,
  },
  // roller cassette
  cassetteColour: {
    description: '',
    id: 0,
  },
  otherColour: '',
  // roller shutter
  angleType: '',
  bottomGuide: '',
  pattern: '',
  bottomAngle: 0,
  heightL: 0,
  heightR: 0,
  pelmetColor: {
    color: '',
    id: 0,
  },
  guideColor: {
    color: '',
    id: 0,
  },
  bottomBarColor: {
    color: '',
    id: 0,
  },
  slatPrimaryColor: {
    color: '',
    id: 0,
  },
  slat2Color: {
    color: '',
    id: 0,
  },
  crankColors:{
    color: '',
    id: 0,
  },
  shutterType: {
    description: '',
    id: 0,
  },
  trackBrand: {
    description: '',
    id: 0,
  },
  guideType: {
    description: '',
    id: 0,
  },
  //  protecta
  fabricCatalog: {
    description: '',
    id: 0,
  },
  fabricName: '',
  channelColor: {
    color: '',
    id: 0,
  },
  hoodSize: {
    description: '',
    id: 0,
  },
  topRollerSize: {
    description: '',
    id: 0,
  },
  hoodColor: {
    color: '',
    id: 0,
  },
  powderColor:'',
  // awning
  bcaa: {
    description: '',
    id: 0,
  },
  valance: 0,
  pelmetWidth:0,
  valanceStyle: {
    description: '',
    id: 0,
  },
  hood: '',
  // shop front awning
  jhookHeight: 0,
  // EZE awning
  hoodType: {
    description: '',
    id: 0,
  },
};

export interface ExtraRequirement {
  id: number;
  requirement: string;
  price: number;
  length: number;
  unit_price: number;
  price_index: number;
}

export interface ItemsData {
  rubberSeal? :string;
  cost?:number;
  itemCost ?:string;
  description?: string;
  delete_flag?: boolean;
  isFitted: boolean;
  price?: string;
  trackCut?: string;
  bladeCut?: string;
  noBracket?:string;
  noOfBlade?: string;
  id?: number;
  productId: string;
  controlSide?: string;
  controlStack?: string;
  controlStyle?: string;
  cassetteType?: string;
  bottomWrap?: string;
  fabricDetail?: string;
  fabricDetail2?: string;
  realWidth?: string;
  realHeight?: string;
  fitting?: string;
  stack?: string;
  bracketType?: string;
  trackType?: string;
  fabricStyle?: string;
  height?: number;
  leftReturn?: number;
  rightReturn?: number;
  make?: number;
  links?: string;
  location?: string;
  note?: string;
  stackDirection?: string;
  controlMat?: string;
  fittingTo?: string;
  width?: number;
  pelmetWidth?: number;
  quantity?: number;
  partColor?: string;
  tPost?: number;
  cutTilt?: number;
  TPostSetting?: string;
  plantationColor?:string;
  slatWidth?: number;
  blindType?: {
    description: string;
    material_id: number;
  };
  trackColour?: {
    color: string;
    id: number;
  };
  controlColor?: {
    color: string;
    id: number;
  };
  cassetteColor?: {
    color: string;
    id: number;
  };
  subType?: {
    description: string;
    id: number;
  };
  trackBrand?: {
    description: string;
    id: number;
  };
  // roller blinds
  tubeType?:string;
  topRoller?: string;
  fabricWidth?: string;
  totalFabricWidth?:string;
  fabricDrop?: string;
  bottomBarCal?: string;
  controlLength?: string;
  rollerStyle?: string;
  extraBracket?: number;
  extraSlat?: number;
  bottomSupport?:string;
  material?: string;
  slatSize?: string;
  foldingType?: string;
  fabricRotation?: string;
  blindPelmet?: string;
  itemList?: itemGroup[];
  tieBack?: string;
  layout?: string;
  customLayout?: string;
  planColor?: {
    color: string;
    id: number;
  };
  hingeColor?: {
    color: string;
    id: number;
  };
  track?:string;
  handle?:string;
  bracketColor?: {
    color: string;
    id: number;
  };
  slatColor?: {
    color: string;
    id: number;
  };
  foldingColor?: {
    color: string;
    id: number;
  };
  weatherColor?: {
    color: string;
    id: number;
  };
  curverColor?: {
    color: string;
    id: number;
  };
  trackColor?: {
    color: string;
    id: number;
  };
  wandColor?: {
    color: string;
    id: number;
  };
  // bottomBarOther?: string;
  planMaterial?: {
    description: string;
    id: number;
  };
  frameCode?: string;
  mountMethod?: string;
  top?: boolean;
  right?: boolean;
  left?: boolean;
  bottom?: boolean;
  uneven?: boolean;
  noPanel?: number;
  midRail?:number;
  mount?: string;
  controlRod?: string;

  planBladeSize?: string;
  romanTrack?: {
    description: string;
    id: number;
  };
  operation?: {
    description: string;
    id: number;
  };
  rafterBracket?: {
    description: string;
    id: number;
  };
  curtainHeading?: {
    description: string;
    id: number;
  };
  valanceHook?: {
    description: string;
    id: number;
  };
  liningOption?: {
    description: string;
    id: number;
  };
  bottomBarOpt?:{
    description: string;
    id: number;
  };
  rollerSize?: string;
  bottomBar?: {
    description: string;
    id: number;
  };
  bottomBrand?: {
    description: string;
    id: number;
  };
  bottomBarBrand?: {
    description: string;
    id: number;
  };
  bracket?: {
    description: string;
    id: number;
  };
  fabricType?: {
    description: string;
    id: number;
  };
  fabricType2?: {
    description: string;
    id: number;
  };
  fixType?: string;
  curverPattern?: {
    description: string;
    id: number;
  };

  // roller cassette
  cassetteColour?: {
    description: string;
    id: number;
  };
  fabricCol?: {
    color: string;
    id: number;
  };
  glideColor?: {
    color: string;
    id: number;
  };
  otherColour?: string;
  // roller shutter
  pelmetSizeCal?: string;
  pelmetCut?: string;
  slatCut?: string;
  noSlat?: string;
  bot?: string;
  oct?: string;
  guideL?: string;
  guideR?: string;
  axels?: string;
  motor?: string;
  bottomGuide?: string;
  pattern?: string;
  bottomAngle?: number;
  heightL?: number;
  heightR?: number;
  pelmetColor?: {
    color: string;
    id: number;
  };
  guideColor?: {
    color: string;
    id: number;
  };
  bottomBarColor?: {
    color: string;
    id: number;
  };
  slatPrimaryColor?: {
    color: string;
    id: number;
  };
  slat2Color?: {
    color: string;
    id: number;
  };
  crankColor?: {
    color: string;
    id: number;
  };
  shutterType?: {
    description: string;
    id: number;
  };
  partType?: {
    description: string;
    id: number;
  };
  guideType?: {
    description: string;
    id: number;
  };
  // protecta
  hoodCut?: string;
  tubeCut?: string;
  bottomRail?: string;
  channelLeft?: string;
  channelRight?: string;
  tentionTrackLeft?: string;
  tentionTrackRight?: string;
  armExtrusion?: string;
  slidingRail?: string;
  wireLength?: string;
  fabricWidthOnlySkin?: string;
  fabricWidthIncZip?: string;
  fabricCatalog?: {
    description: string;
    id: number;
  };
  fabricName?: string;
  channelColor?: {
    color: string;
    id: number;
  };
  hoodColor?: {
    color: string;
    id: number;
  };
  powderColor?: string;
  hoodSize?: {
    description: string;
    id: number;
  };
  topRollerSize?: {
    description: string;
    id: number;
  };
  // awning
  bottomBarPocket?: string;
  totalHeight?: string;
  bottomBarWidth?: string;
  fabricWidthCal?: string;
  hems?: string;
  fabricUsed?: string;
  motorSize?: string;
  hoodWidth?: string;
  tubeSize?:string;
  hood?: string;
  valance?: number;
  bcaa?: {
    description: string;
    id: number;
  };
  valanceStyle?: {
    description: string;
    id: number;
  };
  // shop front awning
  extraHeight?: string;
  pocketHeight?: string;
  awningHeight?: string;
  botBarPocket?: string;
  totalFabicHeight?: string;
  topTimberWidth?: string;
  totalWidth?: string;
  fabricUsedCal?: string;
  cordLength?: string;
  jhookHeight?: number;
  controlLooking?: string;
  // SRS awning
  outerChannelLeft?: string;
  outerChannelRight?: string;
  innerChannelLeft?: string;
  innerChannelRight?: string;
  // EZE awning
  hoodType?: {
    description: string;
    id: number;
  };
  // extra
  extra_info?: ExtraRequirement[];
  extra_price?: number;
  
}

const ItemConstant = {
  InitialItem,
};

export default ItemConstant;
